export default __webpack_public_path__ + "static/meshmate-ruth-ikegah-0f291f0f907d641dadea5f99ba943607.webp";